import validatorLib from 'validator';

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const numericOnlyNormalization = value => {
  if (!value) {
    return '';
  }
  return value.replace(/[^\d]/g, '');
};

export const simpleSetValueFormMutator = {
  setValue: ([field, value], state, { changeValue }) =>
    changeValue(state, field, () => value),
};

export const requiredStringValidation = (
  message = 'This field is required'
) => value =>
  !value || validatorLib.isEmpty(value.trim()) ? message : undefined;

const isEmptyValue = value => {
  return value === undefined || value === null || value === '';
};

export const requiredFieldValidation = (value, fieldName = 'This field') => {
  if (isEmptyValue(value)) {
    return `${fieldName} is required`;
  }
  return null;
};

export const rangeValidation = (value, min, max, fieldName = 'Value') => {
  if (value < min || value > max) {
    return `${fieldName} must be between ${min} and ${max}`;
  }
  return null;
};

export const minValueValidation = (value, min, fieldName = 'Value') => {
  if (value < min) {
    return `${fieldName} must be ${
      min === 0 ? 'a positive number' : `at least ${min}`
    }`;
  }
  return null;
};

export const requiredArrayValidation = (value, fieldName) => {
  if (!value || value.length === 0) {
    return `Please select at least one ${fieldName}`;
  }
  return null;
};
